$.ready(function() {
	var fancy = {};
	var loader = window.loader;
	
	fancy.base = $.div().addClass('fancy base').prependTo(loader);
	fancy.guy = $.div().addClass('fancy guy').prependTo(fancy.base);
	
	fancy.hair = [];
	fancy.hair[0] = $.div().addClass('leftUpper hair').appendTo(fancy.guy);
	fancy.hair[1] = $.div().addClass('leftLower hair').appendTo(fancy.guy);
	fancy.hair[2] = $.div().addClass('right hair').appendTo(fancy.guy);
	
	fancy.earrings = [];
	fancy.earrings[0] = $.div().addClass('left earring').appendTo(fancy.guy);
	
	fancy.feathers = $.div().addClass('feathers').appendTo(fancy.guy);
	
	fancy.backdrop = $.div('backdrop').prependTo(loader);
	fancy.face = $.div().addClass('face').appendTo(fancy.guy);
	fancy.blink = $.div().addClass('blink').appendTo(fancy.guy);
	fancy.smile = $.div().addClass('smile').appendTo(fancy.guy);
	
	fancy.frame = $.div().addClass('frame').appendTo(fancy.base);
	fancy.logo = $.div().addClass('logo').appendTo(fancy.base);
	fancy.info = $.div().addClass('action').appendTo(fancy.base);
	fancy.info = $.div().addClass('xtra').appendTo(fancy.base);
	fancy.info = $.div().addClass('TwoinOne').appendTo(fancy.base);
	fancy.konami = $.div().addClass('konami').appendTo(fancy.base);
	fancy.legal = $.div().addClass('legal').appendTo(fancy.base);
	
	fancy.earrings[1] = $.div().addClass('right earring').appendTo(fancy.guy);
	
	fancy.thumb = $.div().addClass('thumb').appendTo(fancy.guy);
	
	fancy.mask = $.div().addClass('mask').appendTo(fancy.guy);
	
	fancy.arms = [];
	fancy.arms[0] = $.div().addClass('left arm').appendTo(fancy.guy);
	
	game.on('scale', function(e) {
		e.detail.resize({ width: 1920, height: 1080, font: 24 }, fancy.base);
		
		fancy.guy.attr('class', '');
		
		setTimeout(function() {
			fancy.guy.attr('class', 'fancy guy');
		}, 10);
	});
});



/** WEBPACK FOOTER **
 ** ./public-src/fancy_belly.js
 **/